const doc = [({"en":({"js":({"layout":({"impersonation_banner":({"back_to_admin":"Back to admin", "signed_in_as":"You are signed in as %{name} via admin."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;